'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidUnlock = function IoAndroidUnlock(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.4 14.5c1.7 0 3.1 1.4 3.1 3.2v15.6c0 1.7-1.4 3.1-3.1 3.1h-18.8c-1.7 0-3.1-1.4-3.1-3.1v-15.6c0-1.8 1.4-3.2 3.1-3.2h14.2v-3.1c0-2.6-2.1-4.8-4.8-4.8s-4.8 2.2-4.8 4.8h-3c0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8v3.1h1.6z m-9.4 14.3c1.7 0 3.1-1.5 3.1-3.2s-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1 1.4 3.2 3.1 3.2z' })
        )
    );
};

exports.default = IoAndroidUnlock;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-unlock.js
// module id = 1919
// module chunks = 0